export const MOBILE_CONSTANTS: {[key: string]: any} = {
  soSureFaqUrl: 'https://wearesosure.com/faq',
  sosure: {
    uk: {
      faq: 'https://wearesosure.com/faq',
      label: 'wearesosure.com/faq'
    }
  },
  huddle: {
    uk: {
      faq: 'https://huddleinsurance.com/uk/faqs',
      label: 'huddleinsurance.com/uk/faqs'
    }
  }
};